import { CategoriesScreen } from '../features/categories/CategoriesScreen'
import { useShell } from '../app/outlet'

export function CategoriesPage() {
  const { toast } = useShell()
  return <CategoriesScreen onToast={toast} />
}
